import PlayButtonInverse from '../../src/legacy/PlayButtonInverse.tsx';
export default PlayButtonInverse;
